import { render, staticRenderFns } from "./IconCallback.vue?vue&type=template&id=04c9c7b3&"
import script from "./IconCallback.vue?vue&type=script&lang=js&"
export * from "./IconCallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports